import { notification } from 'antd';
const createNotification = (type, message, description, duration, placement) => {
  notification[type]({
    message,
    description,
    duration,
    placement
  });
};
export default createNotification;
